
export default [
    // Rutas separadas por vista
    {
        path: "/configuraciones-adicionales-ingresos",
        name: "configuraciones-adicionales-ingresos",
        component: () =>
            import(/* webpackChunkName: "config-adicionales-ingresos" */ "../pages/IngresosPage.vue"),
    },
    {
        path: "/configuraciones-adicionales-descuentos",
        name: "configuraciones-adicionales-descuentos",
        component: () =>
            import(/* webpackChunkName: "config-adicionales-descuentos" */ "../pages/DescuentosPage.vue"),
    },
    {
        path: "/configuraciones-adicionales-aguinaldo",
        name: "configuraciones-adicionales-aguinaldo",
        component: () =>
            import(/* webpackChunkName: "config-adicionales-aguinaldo" */ "../pages/AguinaldoPage.vue"),
    },
    // Compatibilidad: redirige la ruta antigua a Ingresos
    {
        path: "/configuraciones-adicionales",
        redirect: { name: "configuraciones-adicionales-ingresos" },
    },
];